import React from 'react';
import { Spinner } from 'react-bootstrap';

const AppLoading = () => {
    return (
        <div style={{ textAlign: 'center' }}>
            <Spinner animation="border" />
        </div>
    );
};

export default AppLoading;